<vzc-side-drawer
  insightsPanelDrawer
  #ipDrawer="insightsPanelDrawer"
  [mode]="(isMobile$ | async) ? 'over' : (ipDrawer.drawerMode$ | async)"
  [userPreferences]="userPreferences$ | async"
  [hasAccess]="hasInsightsAccess$ | async"
  [ngClass]="{ 'fullscreen-mode': isFullscreen$ | async }"
>
  <ng-content></ng-content>
</vzc-side-drawer>
